"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const ServiceElement_vue_1 = __importDefault(require("../../../components/frontend/ServiceElement.vue"));
const Alert_vue_1 = __importDefault(require("../../../components/Alert.vue"));
const vue_3 = require("vue");
const LocationsStore_1 = require("../../../stores/locations/LocationsStore");
const bookAppointmentStore_1 = require("../../../stores/bookAppointment/bookAppointmentStore");
exports.default = (0, vue_1.defineComponent)({
    __name: 'Services',
    setup(__props) {
        //import CustomInput from "../../../components/frontend/CustomInput.vue";
        //import { ShopInput } from "../../../components/Form";
        const errorMessage = (0, vue_3.ref)("");
        const bookAppointmentStore = (0, bookAppointmentStore_1.useBookAppointmentStore)();
        const locationStore = (0, LocationsStore_1.useLocationStore)();
        (0, vue_3.watch)(() => [bookAppointmentStore.tyreDatas.tyreDiameter], async ([newTyreDiameter]) => {
            if (newTyreDiameter) {
                await locationStore
                    .getLocations()
                    .then(() => {
                    bookAppointmentStore.reservedServiceLocationId = null;
                    errorMessage.value = "";
                })
                    .catch((error) => {
                    bookAppointmentStore.reservedServiceLocationId = null;
                    errorMessage.value = error.toString();
                });
            }
        }, { immediate: true } // Azonnali futtatás bekapcsolva
        );
        const changeLocation = (serviceId) => {
            bookAppointmentStore.tyreFittingServiceSKU = null;
            bookAppointmentStore.reservedServiceLocationId = serviceId;
            bookAppointmentStore.tyreDatas.isWheel = null;
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (errorMessage.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Alert_vue_1.default, {
                        key: 0,
                        message: errorMessage.value,
                        icon: ""
                    }, null, 8, ["message"]))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(locationStore).locations, (location, index) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ServiceElement_vue_1.default, {
                        key: index,
                        city: location.city,
                        address: location.address,
                        img: location.image,
                        onChange: ($event) => (changeLocation(location.id))
                    }, null, 8, ["city", "address", "img", "onChange"]));
                }), 128))
            ], 64));
        };
    }
});
